import React, { useMemo } from "react";
import IntegrationTimeline from "../../../../common/components/integration-timeline/IntegrationTimeline";
import type { IntegrationMilestone } from "../../../../pages/hid-admin/dashboard/partner-organizations/partner-list/integration-status/integrationStatusTypes";
import { ProjectStageData } from "../../types";

interface ProjectPipelineRowProps {
  stages: ProjectStageData[];
}

const mapStageToMilestone = (stage: ProjectStageData): IntegrationMilestone => ({
  label: stage.label,
  state: stage.state,
  ...(stage.state === "completed" && stage.date
    ? { completedDate: stage.date }
    : {}),
  ...((stage.state === "in-progress" || stage.state === "on-hold") && stage.date
    ? { statusDate: stage.date }
    : {}),
  ...(stage.state === "pending" && stage.statusLabel
    ? { statusLabel: stage.statusLabel }
    : {}),
});

const ProjectPipelineRow: React.FC<ProjectPipelineRowProps> = ({ stages }) => {
  const milestones = useMemo(
    () => stages.map(mapStageToMilestone),
    [stages]
  );

  return (
    <div className="project-pipeline-row">
      <IntegrationTimeline
        milestones={milestones}
        className="integration-timeline--dashboard"
        pendingLabel="Not Started"
      />
    </div>
  );
};

export default ProjectPipelineRow;
